<template>
  <span
    :is="tag"
    class="cordel-typography-subtitle"
  >
    <slot />
  </span>
</template>

<script>
  const HIERARCHY = ['h1', 'h2', 'h3', 'h4'];

  export default {
    name: 'CordelTypographySubtitle',
    props: {
      hierarchy: {
        type: String,
        default: HIERARCHY[1],
        validator(value) {
          return HIERARCHY.includes(value);
        },
      },
    },
    computed: {
      tag() {
        switch (this.hierarchy) {
          case 'h1':
            return 'h5';
          default:
            return 'h6';
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .cordel-typography-subtitle {
    color: var(--cordel-legacy-color-neutral-dark);
    font-weight: var(--cordel-legacy-font-weight-regular);
    line-height: var(--cordel-legacy-line-height-l);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      line-height: var(--cordel-legacy-line-height-m);
      margin-top: 0.25em;
    }

    @at-root {
      h5#{&} {
        font-size: var(--cordel-legacy-font-size-l);

        @media all and (max-width: $cordel-breakpoint-mobile) {
          font-size: var(--cordel-legacy-font-size-m);
        }
      }

      h6#{&} {
        font-size: var(--cordel-legacy-font-size-m);

        @media all and (max-width: $cordel-breakpoint-mobile) {
          font-size: var(--cordel-legacy-font-size-s);
        }
      }
    }
  }
</style>
